import { getCurrentUser } from '../../user/currentUserSelector';
import { useSelector } from 'react-redux';
import logger from '../../logger';
import { Capacitor } from '@capacitor/core';
import { CAPACITOR_HAPTICS_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import { useCallback } from 'react';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { getIsHapticsEnabled } from './hapticsUtils';

// See the Haptics Capacitor plugin for all possible haptics styles https://capacitorjs.com/docs/apis/haptics
const hapticsImpactLight = async () => Haptics.impact({ style: ImpactStyle.Light });
const hapticsImpactMedium = async () => Haptics.impact({ style: ImpactStyle.Medium });

export enum HapticsStyle {
    ImpactLight = 'ImpactLight',
    ImpactMedium = 'ImpactMedium',
}

const hapticsFunctions: { [key in HapticsStyle]: () => Promise<void> } = {
    [HapticsStyle.ImpactLight]: hapticsImpactLight,
    [HapticsStyle.ImpactMedium]: hapticsImpactMedium,
};

const isHapticsAvailable = () => Capacitor.isNativePlatform() && Capacitor.isPluginAvailable(CAPACITOR_HAPTICS_PLUGIN);

export const usePerformHapticFeedback = () => {
    const currentUser = useSelector(getCurrentUser);
    const isHapticsEnabled = getIsHapticsEnabled(currentUser);

    return useCallback(
        async (hapticsStyle: HapticsStyle) => {
            if (!isHapticsEnabled) return;

            if (!isHapticsAvailable()) return;

            const hapticsFunction = hapticsFunctions[hapticsStyle];
            if (!hapticsFunction) return;

            try {
                await hapticsFunction();
            } catch (error) {
                logger.error('Haptics error', error);
            }
        },
        [isHapticsEnabled],
    );
};
